import React, { useState, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Sidebar from './Sidebar';
import Header from './Header';
import AIWidget from '../AIWidget';
import AmbientBackground from '../AmbientBackground';
import CommandPalette from '../CommandPalette';
import KeyboardShortcuts from '../KeyboardShortcuts';
import ListSkeleton from '../Skeleton';
import { useAuth } from '../../context/AuthContext';
import { isSuperAdmin } from '../../lib/permissions';

export default function AppLayout() {
  // Repli du panneau (rail seul) — mémorisé entre les sessions.
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => localStorage.getItem('adalia-rail-collapsed') === '1');
  const toggleSidebar = () => setSidebarCollapsed(c => { const n = !c; localStorage.setItem('adalia-rail-collapsed', n ? '1' : '0'); return n; });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();
  const isSuper = isSuperAdmin(user?.role, user?.is_super_admin);
  // Le SuperAdmin administre la plateforme (pas un cabinet) : pas d'assistant cabinet.
  const showWidget = !isSuper && location.pathname !== '/chat';

  return (
    <div className="min-h-screen flex" style={{background:'var(--bg-primary)'}}>
      <AmbientBackground />

      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      </div>
      
      {/* Mobile Sidebar (Sheet) */}
      <div className="md:hidden">
        <Sidebar 
          collapsed={false} 
          mobile={true}
          isOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        />
      </div>

      <div className={`relative z-10 flex-1 flex flex-col transition-all duration-300 ${sidebarCollapsed ? 'md:ml-[60px]' : 'md:ml-[284px]'}`}>
        <Header onMenuClick={() => setMobileMenuOpen(true)} />
        <main className="flex-1 p-3 md:p-6 overflow-auto">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.32, ease: [0.22, 0.61, 0.36, 1] }}
          >
            {/* Suspense ICI (pas au-dessus du shell) : pendant le chargement d'un
                chunk de page, la sidebar et le header restent en place. */}
            <Suspense fallback={<ListSkeleton kpi={4} rows={6} />}>
              <Outlet />
            </Suspense>
          </motion.div>
        </main>
      </div>
      {showWidget && <AIWidget />}
      {!isSuper && <CommandPalette />}
      {!isSuper && <KeyboardShortcuts />}
    </div>
  );
}
